export const UPDATE_FLIGHT_SEARCH = 'UPDATE_FLIGHT_SEARCH';
export const UPDATE_SEARCH_HOTEL = 'UPDATE_SEARCH_HOTEL';
export const UPDATE_FLIGHT_SEARCH_PASSENGERS = 'UPDATE_FLIGHT_SEARCH_PASSENGERS';
export const UPDATE_HOTEL_SEARCH_PASSENGERS = 'UPDATE_HOTEL_SEARCH_PASSENGERS';
export const UPDATE_CHILDREN_AGE = 'UPDATE_CHILDREN_AGE';
export const SHOW_LOCATION_SEARCHER = 'SHOW_LOCATION_SEARCHER';
export const SHOW_SEARCHER_HOTEL = 'SHOW_SEARCHER_HOTEL';
export const SET_FLIGHT_LOCATIONS = 'SET_FLIGHT_LOCATIONS';
export const SET_LOCATIONS_HOTEL = 'SET_LOCATIONS_HOTEL';
export const SET_FLIGHT_HISTORY = 'SET_FLIGHT_HISTORY';
export const SET_HISTORIC_HOTEL = 'SET_HISTORIC_HOTEL';
export const SHOW_FLIGHT_HISTORY = 'SHOW_FLIGHT_HISTORY';
export const SHOW_HISTORIC_HOTEL = 'SHOW_HISTORIC_HOTEL';
export const UPDATE_FLIGHT_RESULTS = 'UPDATE_FLIGHT_RESULTS';
export const DISABLE_FLIGHT_RESULTS_BOOKINGS = 'DISABLE_FLIGHT_RESULTS_BOOKINGS';
export const DISABLE_BUTTONS_RESULTS_HOTELS = 'DISABLE_BUTTONS_RESULTS_HOTELS';

export const UPDATE_RESULT_SEARCH = 'UPDATE_RESULT_SEARCH';

export const SET_PASSENGER = 'SET_PASSENGER';
export const SET_ALL_PASSENGERS = 'SET_ALL_PASSENGERS';
export const UPDATE_FLIGHT_PASSENGER = 'UPDATE_FLIGHT_PASSENGER';
export const UPDATE_HOTEL_PASSENGER = 'UPDATE_HOTEL_PASSENGER';
export const PREVIOUS_PASSENGER = 'PREVIOUS_PASSENGER';
export const SET_ADDRESS = 'SET_ADDRESS';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const SET_SHOW = 'SET_SHOW';
export const SET_DESCRIPTION = 'SET_DESCRIPTION';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLEAN_SEARCH = 'CLEAN_SEARCH';
export const VALIDATE_SEARCH_FORM = 'VALIDATE_SEARCH_FORM';
export const ENABLE_SEARCH_BUTTON = 'ENABLE_SEARCH_BUTTON';

export const SHOW_MAPS = 'SHOW_MAPS';
export const SHOW_DETAILS = 'SHOW_DETAILS';
export const SHOW_INFO_IN_RESULTS = 'SHOW_INFO_IN_RESULTS';
export const FILL_SUGGESTIONS = 'FILL_SUGGESTIONS';
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS';

export const SET_FILTERS = 'SET_FILTERS';
export const SHOW_PASSENGERS = 'SHOW_PASSENGERS';
export const SHOW_SHARE = 'SHOW_SHARE';